import React from "react";
import PropTypes from "prop-types";
import ChatFormInput from "../../shared/ChatFormInput/ChatFormInput";
import SendButton from "../../shared/SendButton/SendButton";
import ContainerReponse from "../../Layout/ContainerReponse/ContainerReponse";
//================ STEP 1 ===============

const HandleLastName = ({
                            messageValue,
                            addMessage,
                            addBotMessage,
                            inputDisabled,
                            setInputDisable,
                            setUserInfos,
                            loadingBotMessage,
                            responseBotDelay,
                            setStep,
                            updateLastname,
                            handleChange
                        }) => {
    const handleLastnameSubmit = (e) => {
        // ***Regex*** :N'accepte pas les chiffres
        const nameRegex = /^([^0-9]*)$/;
        if (!nameRegex.test(messageValue)) {
            loadingBotMessage(true);
            e.preventDefault();
            addMessage(messageValue);
            setInputDisable(true);
            setTimeout(() => {
                loadingBotMessage(false);
                addBotMessage("Votre prénom nom semble comporter des chiffres. Êtes vous sûr de l'avoir écrit correctement", "bot");
                setInputDisable(false);
            }, responseBotDelay);
        } else {
            if (messageValue === "") {
                e.preventDefault();
            } else {
                loadingBotMessage(true);
                e.preventDefault();
                addMessage(messageValue);
                setUserInfos(messageValue, "lastname");
                setInputDisable(true);
                setTimeout(() => {
                    loadingBotMessage(false);
                    addBotMessage("C’est parfait. J’ai maintenant besoin de votre adresse.", "bot");
                    updateLastname();
                    setInputDisable(false);
                    setStep(2);
                }, responseBotDelay);
            }
        }
    };
    return (
        <ContainerReponse>
            <ChatFormInput
                onSubmit={handleLastnameSubmit}
                toggleFocusOn={inputDisabled}
                type="text"
                label="Quel est votre nom ?"
                value={messageValue}
                onChange={handleChange}
                valueToActive={messageValue}
                disabled={inputDisabled ? "disabled" : ""}
                required={true}
            >
                <SendButton disabled={inputDisabled || !messageValue ? "disabled" : ""}/>
            </ChatFormInput>
        </ContainerReponse>
    );
};

HandleLastName.propTypes = {
    responseBotDelay: PropTypes.number,
    setStep: PropTypes.func,
    handleChange: PropTypes.func,
    setMessageValue: PropTypes.func,
    messageValue: PropTypes.string,
    inputDisabled: PropTypes.bool,
    addMessage: PropTypes.func,
    addBotMessage: PropTypes.func,
    setInputDisable: PropTypes.func,
    setUserInfos: PropTypes.func,
    updateLastname: PropTypes.func,
    loadingBotMessage: PropTypes.func,
};

export default HandleLastName;
